// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Document / canvas chat layout =====
   Full-width turn rows on the off-white chat surface. The row background is set
   inline per role (ChatMessage.tsx): assistant = white "paper", user = light
   tint. Content sits in a centered 800px reading column. Borders/surfaces derive
   from currentColor so they adapt to the row's text color in light and dark. */
.chat-message {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    animation: fadeIn 0.3s ease-in-out;
}

/* User turn: avatar sits beside the bubble on one row (no name label). */
.user-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.user-row .message-avatar {
    margin-top: 4px; /* nudge the avatar to line up with the bubble's first line */
}

.messages.rtl .user-row {
    flex-direction: row-reverse;
}

/* User turns get a small rounded bubble around their text; the assistant stays
   plain full-width. The bubble hugs its content (inline-block) and tucks its
   corner toward the avatar. */
.chat-message.user .message-text {
    display: inline-block;
    max-width: 100%;
    padding: 9px 14px;
    border-radius: 14px;
    border-top-left-radius: 4px;
    background: color-mix(in srgb, currentColor 7%, transparent);
}

.chat-message.user .message-text p {
    margin: 0;
}

.messages.rtl .chat-message.user .message-text {
    border-top-left-radius: 14px;
    border-top-right-radius: 4px;
}

.message-inner {
    max-width: 800px;
    margin: 0 auto;
    padding: 22px 28px;
}

.message-head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 9px;
}

.message-avatar {
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Scale the MUI bot avatar down to header size. */
.message-avatar .MuiAvatar-root {
    width: 26px !important;
    height: 26px !important;
}

.user-avatar {
    background: #00314f;
    color: #fff;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
}

.message-author {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.01em;
    opacity: 0.95;
}

.message-text {
    font-size: 15px;
    line-height: 1.62;
}

.message-text a {
    color: #1f8fbf;
    text-decoration: underline;
    text-underline-offset: 2px;
}

.message-text img {
    max-width: 120px;
    max-height: 80px;
    object-fit: contain;
    border-radius: 4px;
    vertical-align: middle;
}

.message-text p, .message-text ul, .message-text li {
    line-height: 1.85;
}

.message-text pre {
    padding: 12px;
    border-radius: 6px;
    overflow-x: auto;
    background: color-mix(in srgb, currentColor 8%, transparent);
}

/* --- Mermaid diagrams --- */
.message-text .mermaid-diagram {
    display: flex;
    /* \`safe center\` centers a diagram that fits, but falls back to start
       alignment when it overflows so its left edge stays scrollable (plain
       \`center\` would clip it out of reach). */
    justify-content: safe center;
    margin: 14px 0;
    padding: 16px;
    /* Light "figure" card in both app themes so the mermaid colors (dark-on-light)
       stay legible regardless of light/dark mode. */
    background: #f4f6f8;
    border: 1px solid rgba(18, 48, 63, 0.14);
    box-shadow: 0 6px 18px rgba(18, 48, 63, 0.07);
    border-radius: 12px;
    /* Cap to the column width so a wider diagram scrolls here instead of
       stretching the whole message. */
    max-width: 100%;
    overflow-x: auto;
}

/* Render at natural size (see useMaxWidth:false). A diagram narrower than the
   bubble stays centered; a wider one keeps its size and the container scrolls
   horizontally rather than shrinking the labels to fit. */
.message-text .mermaid-diagram svg {
    height: auto;
    flex-shrink: 0;
}

/* htmlLabels render node text as real DOM inside <foreignObject>. Keep the chat's
   global typography out of it — line-height:2 on p/li and inherited margins would
   distort label metrics and re-introduce clipping. */
.message-text .mermaid-diagram foreignObject div,
.message-text .mermaid-diagram foreignObject span,
.message-text .mermaid-diagram foreignObject p {
    line-height: 1.4 !important;
    margin: 0 !important;
    padding: 0 !important;
}

/* Clickable (report-linked) nodes: give them an accent border so it's obvious
   they open a report, and lift them slightly on hover. */
.message-text .mermaid-diagram a.mermaid-node-link {
    cursor: pointer;
}
.message-text .mermaid-diagram a.mermaid-node-link rect,
.message-text .mermaid-diagram a.mermaid-node-link polygon {
    stroke: #1D9E98;
    stroke-width: 2px;
}
.message-text .mermaid-diagram a.mermaid-node-link:hover {
    filter: brightness(1.08);
}
.message-text .mermaid-diagram a.mermaid-node-link:hover rect,
.message-text .mermaid-diagram a.mermaid-node-link:hover polygon {
    stroke-width: 3px;
}
.message-text .mermaid-diagram a.mermaid-node-link:hover text,
.message-text .mermaid-diagram a.mermaid-node-link:hover foreignObject span,
.message-text .mermaid-diagram a.mermaid-node-link:hover foreignObject div {
    text-decoration: underline;
}

/* Fallback when the diagram source is invalid — show it as plain code. */
.message-text .mermaid-error {
    display: block;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px dashed rgba(200, 60, 60, 0.55);
    background: color-mix(in srgb, currentColor 6%, transparent);
    white-space: pre-wrap;
    font-size: 13px;
}

/* A diagram isn't real preformatted text — drop the <pre> chrome around it. */
.message-text pre:has(.mermaid-diagram),
.message-text pre:has(.mermaid-error) {
    padding: 0;
    background: none;
    overflow: visible;
}

/* --- Tables --- */
/* The wrapper scrolls horizontally so wide tables never overflow the bubble. */
.message-text .table-wrap {
    max-width: 100%;
    overflow-x: auto;
    margin: 12px 0;
    border: 1px solid color-mix(in srgb, currentColor 20%, transparent);
    border-radius: 10px;
    -webkit-overflow-scrolling: touch;
}

.message-text table {
    border-collapse: collapse;
    width: 100%;
    /* Force columns wider than the narrow bubble → horizontal scroll kicks in. */
    min-width: 560px;
    font-size: 13.5px;
    line-height: 1.45;
}

.message-text th,
.message-text td {
    padding: 9px 12px;
    text-align: start;
    vertical-align: top;
    border-bottom: 1px solid color-mix(in srgb, currentColor 14%, transparent);
    border-inline-end: 1px solid color-mix(in srgb, currentColor 10%, transparent);
}

.message-text th:last-child,
.message-text td:last-child {
    border-inline-end: none;
}

.message-text thead th {
    background: color-mix(in srgb, currentColor 9%, transparent);
    font-weight: 600;
    white-space: nowrap;
    position: sticky;
    top: 0;
}

.message-text tbody tr:nth-of-type(even) {
    background: color-mix(in srgb, currentColor 4%, transparent);
}

.message-text tbody tr:last-child td {
    border-bottom: none;
}

.message-text td a {
    color: #1f8fbf;
    text-decoration: underline;
}

/* Keep report thumbnails tidy inside cells. */
.message-text td img {
    max-width: 72px;
    max-height: 56px;
}

/* Dark mode support */


@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}



.message-type {
    font-size: 12px;
    color: #666;
    margin-left: 8px;
    padding: 2px 6px;
    background: #f0f0f0;
    border-radius: 4px;
}


@keyframes thinking-pulse {
  0%, 100% { opacity: 0.5; }
  50% { opacity: 1; }
}

.thinking-indicator {
  animation: thinking-pulse 1.4s ease-in-out infinite;
  font-style: italic;
}

.message {
  cursor: default;
}

.message:active,
.message:focus {
  outline: none;
}

@media (prefers-color-scheme: dark) {
    .message-type {
        background: #333;
        color: #ccc;
    }


}
/* RTL: mirror the header (avatar + author) to the right; the reading column is
   full-width and the body direction is handled by dir="auto". */
.messages.rtl .message-head {
    flex-direction: row-reverse;
}

/* Right-align the column content so the user's inline-block bubble sits on the
   right (under the "You" header) and the assistant text reads right-to-left. */
.messages.rtl .message-inner {
    text-align: right;
}

.messages.rtl .message-text {
    text-align: right;
}

.message-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
}

.message-choice-btn {
    background: color-mix(in srgb, currentColor 10%, transparent);
    border: 1.5px solid color-mix(in srgb, currentColor 35%, transparent);
    color: inherit;
    border-radius: 20px;
    padding: 6px 16px;
    font-size: 13px;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
}

.message-choice-btn:hover {
    background: color-mix(in srgb, currentColor 20%, transparent);
    border-color: color-mix(in srgb, currentColor 55%, transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatMessage/ChatMessage.css"],"names":[],"mappings":"AAAA;;;;+EAI+E;AAC/E;IACI,cAAc;IACd,WAAW;IACX,SAAS;IACT,UAAU;IACV,kCAAkC;AACtC;;AAEA,yEAAyE;AACzE;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,eAAe,EAAE,6DAA6D;AAClF;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;8BAE8B;AAC9B;IACI,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,4DAA4D;AAChE;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,kDAAkD;AAClD;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb;;8CAE0C;IAC1C,4BAA4B;IAC5B,cAAc;IACd,aAAa;IACb;oDACgD;IAChD,mBAAmB;IACnB,wCAAwC;IACxC,6CAA6C;IAC7C,mBAAmB;IACnB;sCACkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;;0DAE0D;AAC1D;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;;qDAEqD;AACrD;;;IAGI,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;yDACyD;AACzD;IACI,eAAe;AACnB;AACA;;IAEI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,wBAAwB;AAC5B;AACA;;IAEI,iBAAiB;AACrB;AACA;;;IAGI,0BAA0B;AAC9B;;AAEA,yEAAyE;AACzE;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,4DAA4D;IAC5D,qBAAqB;IACrB,eAAe;AACnB;;AAEA,8EAA8E;AAC9E;;IAEI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,mBAAmB;AACnB,+EAA+E;AAC/E;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mEAAmE;IACnE,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,6EAA6E;IAC7E,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,0EAA0E;IAC1E,8EAA8E;AAClF;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,4DAA4D;IAC5D,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA,8CAA8C;AAC9C;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,sBAAsB;;;AAGtB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;;;AAIA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;IACf;;;AAGJ;AACA;gEACgE;AAChE;IACI,2BAA2B;AAC/B;;AAEA;+EAC+E;AAC/E;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,qEAAqE;IACrE,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,6DAA6D;IAC7D,+DAA+D;AACnE","sourcesContent":["/* ===== Document / canvas chat layout =====\n   Full-width turn rows on the off-white chat surface. The row background is set\n   inline per role (ChatMessage.tsx): assistant = white \"paper\", user = light\n   tint. Content sits in a centered 800px reading column. Borders/surfaces derive\n   from currentColor so they adapt to the row's text color in light and dark. */\n.chat-message {\n    display: block;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    animation: fadeIn 0.3s ease-in-out;\n}\n\n/* User turn: avatar sits beside the bubble on one row (no name label). */\n.user-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n}\n\n.user-row .message-avatar {\n    margin-top: 4px; /* nudge the avatar to line up with the bubble's first line */\n}\n\n.messages.rtl .user-row {\n    flex-direction: row-reverse;\n}\n\n/* User turns get a small rounded bubble around their text; the assistant stays\n   plain full-width. The bubble hugs its content (inline-block) and tucks its\n   corner toward the avatar. */\n.chat-message.user .message-text {\n    display: inline-block;\n    max-width: 100%;\n    padding: 9px 14px;\n    border-radius: 14px;\n    border-top-left-radius: 4px;\n    background: color-mix(in srgb, currentColor 7%, transparent);\n}\n\n.chat-message.user .message-text p {\n    margin: 0;\n}\n\n.messages.rtl .chat-message.user .message-text {\n    border-top-left-radius: 14px;\n    border-top-right-radius: 4px;\n}\n\n.message-inner {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 22px 28px;\n}\n\n.message-head {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 9px;\n}\n\n.message-avatar {\n    flex-shrink: 0;\n    width: 26px;\n    height: 26px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Scale the MUI bot avatar down to header size. */\n.message-avatar .MuiAvatar-root {\n    width: 26px !important;\n    height: 26px !important;\n}\n\n.user-avatar {\n    background: #00314f;\n    color: #fff;\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.message-author {\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.01em;\n    opacity: 0.95;\n}\n\n.message-text {\n    font-size: 15px;\n    line-height: 1.62;\n}\n\n.message-text a {\n    color: #1f8fbf;\n    text-decoration: underline;\n    text-underline-offset: 2px;\n}\n\n.message-text img {\n    max-width: 120px;\n    max-height: 80px;\n    object-fit: contain;\n    border-radius: 4px;\n    vertical-align: middle;\n}\n\n.message-text p, .message-text ul, .message-text li {\n    line-height: 1.85;\n}\n\n.message-text pre {\n    padding: 12px;\n    border-radius: 6px;\n    overflow-x: auto;\n    background: color-mix(in srgb, currentColor 8%, transparent);\n}\n\n/* --- Mermaid diagrams --- */\n.message-text .mermaid-diagram {\n    display: flex;\n    /* `safe center` centers a diagram that fits, but falls back to start\n       alignment when it overflows so its left edge stays scrollable (plain\n       `center` would clip it out of reach). */\n    justify-content: safe center;\n    margin: 14px 0;\n    padding: 16px;\n    /* Light \"figure\" card in both app themes so the mermaid colors (dark-on-light)\n       stay legible regardless of light/dark mode. */\n    background: #f4f6f8;\n    border: 1px solid rgba(18, 48, 63, 0.14);\n    box-shadow: 0 6px 18px rgba(18, 48, 63, 0.07);\n    border-radius: 12px;\n    /* Cap to the column width so a wider diagram scrolls here instead of\n       stretching the whole message. */\n    max-width: 100%;\n    overflow-x: auto;\n}\n\n/* Render at natural size (see useMaxWidth:false). A diagram narrower than the\n   bubble stays centered; a wider one keeps its size and the container scrolls\n   horizontally rather than shrinking the labels to fit. */\n.message-text .mermaid-diagram svg {\n    height: auto;\n    flex-shrink: 0;\n}\n\n/* htmlLabels render node text as real DOM inside <foreignObject>. Keep the chat's\n   global typography out of it — line-height:2 on p/li and inherited margins would\n   distort label metrics and re-introduce clipping. */\n.message-text .mermaid-diagram foreignObject div,\n.message-text .mermaid-diagram foreignObject span,\n.message-text .mermaid-diagram foreignObject p {\n    line-height: 1.4 !important;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n/* Clickable (report-linked) nodes: give them an accent border so it's obvious\n   they open a report, and lift them slightly on hover. */\n.message-text .mermaid-diagram a.mermaid-node-link {\n    cursor: pointer;\n}\n.message-text .mermaid-diagram a.mermaid-node-link rect,\n.message-text .mermaid-diagram a.mermaid-node-link polygon {\n    stroke: #1D9E98;\n    stroke-width: 2px;\n}\n.message-text .mermaid-diagram a.mermaid-node-link:hover {\n    filter: brightness(1.08);\n}\n.message-text .mermaid-diagram a.mermaid-node-link:hover rect,\n.message-text .mermaid-diagram a.mermaid-node-link:hover polygon {\n    stroke-width: 3px;\n}\n.message-text .mermaid-diagram a.mermaid-node-link:hover text,\n.message-text .mermaid-diagram a.mermaid-node-link:hover foreignObject span,\n.message-text .mermaid-diagram a.mermaid-node-link:hover foreignObject div {\n    text-decoration: underline;\n}\n\n/* Fallback when the diagram source is invalid — show it as plain code. */\n.message-text .mermaid-error {\n    display: block;\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px dashed rgba(200, 60, 60, 0.55);\n    background: color-mix(in srgb, currentColor 6%, transparent);\n    white-space: pre-wrap;\n    font-size: 13px;\n}\n\n/* A diagram isn't real preformatted text — drop the <pre> chrome around it. */\n.message-text pre:has(.mermaid-diagram),\n.message-text pre:has(.mermaid-error) {\n    padding: 0;\n    background: none;\n    overflow: visible;\n}\n\n/* --- Tables --- */\n/* The wrapper scrolls horizontally so wide tables never overflow the bubble. */\n.message-text .table-wrap {\n    max-width: 100%;\n    overflow-x: auto;\n    margin: 12px 0;\n    border: 1px solid color-mix(in srgb, currentColor 20%, transparent);\n    border-radius: 10px;\n    -webkit-overflow-scrolling: touch;\n}\n\n.message-text table {\n    border-collapse: collapse;\n    width: 100%;\n    /* Force columns wider than the narrow bubble → horizontal scroll kicks in. */\n    min-width: 560px;\n    font-size: 13.5px;\n    line-height: 1.45;\n}\n\n.message-text th,\n.message-text td {\n    padding: 9px 12px;\n    text-align: start;\n    vertical-align: top;\n    border-bottom: 1px solid color-mix(in srgb, currentColor 14%, transparent);\n    border-inline-end: 1px solid color-mix(in srgb, currentColor 10%, transparent);\n}\n\n.message-text th:last-child,\n.message-text td:last-child {\n    border-inline-end: none;\n}\n\n.message-text thead th {\n    background: color-mix(in srgb, currentColor 9%, transparent);\n    font-weight: 600;\n    white-space: nowrap;\n    position: sticky;\n    top: 0;\n}\n\n.message-text tbody tr:nth-of-type(even) {\n    background: color-mix(in srgb, currentColor 4%, transparent);\n}\n\n.message-text tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.message-text td a {\n    color: #1f8fbf;\n    text-decoration: underline;\n}\n\n/* Keep report thumbnails tidy inside cells. */\n.message-text td img {\n    max-width: 72px;\n    max-height: 56px;\n}\n\n/* Dark mode support */\n\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n\n\n.message-type {\n    font-size: 12px;\n    color: #666;\n    margin-left: 8px;\n    padding: 2px 6px;\n    background: #f0f0f0;\n    border-radius: 4px;\n}\n\n\n@keyframes thinking-pulse {\n  0%, 100% { opacity: 0.5; }\n  50% { opacity: 1; }\n}\n\n.thinking-indicator {\n  animation: thinking-pulse 1.4s ease-in-out infinite;\n  font-style: italic;\n}\n\n.message {\n  cursor: default;\n}\n\n.message:active,\n.message:focus {\n  outline: none;\n}\n\n@media (prefers-color-scheme: dark) {\n    .message-type {\n        background: #333;\n        color: #ccc;\n    }\n\n\n}\n/* RTL: mirror the header (avatar + author) to the right; the reading column is\n   full-width and the body direction is handled by dir=\"auto\". */\n.messages.rtl .message-head {\n    flex-direction: row-reverse;\n}\n\n/* Right-align the column content so the user's inline-block bubble sits on the\n   right (under the \"You\" header) and the assistant text reads right-to-left. */\n.messages.rtl .message-inner {\n    text-align: right;\n}\n\n.messages.rtl .message-text {\n    text-align: right;\n}\n\n.message-buttons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-top: 10px;\n}\n\n.message-choice-btn {\n    background: color-mix(in srgb, currentColor 10%, transparent);\n    border: 1.5px solid color-mix(in srgb, currentColor 35%, transparent);\n    color: inherit;\n    border-radius: 20px;\n    padding: 6px 16px;\n    font-size: 13px;\n    cursor: pointer;\n    transition: background 0.2s, border-color 0.2s;\n}\n\n.message-choice-btn:hover {\n    background: color-mix(in srgb, currentColor 20%, transparent);\n    border-color: color-mix(in srgb, currentColor 55%, transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
